import React from "react";
import OhlgsAssessmentFlow from "./OhlgsAssessmentFlow";

function buildDefaultMmdaName(locationName) {
  return locationName || "";
}

export default function DistrictOhlgsReport() {
  return (
    <OhlgsAssessmentFlow
      workflowLabel="District MMDA OHLGS"
      level="district"
      badgeLabel="District MMDA OHLGS"
      pageTitle="OHLGS District Assessment"
      nameFieldLabel="Name of MMDA"
      locationSummaryLabel="Selected District"
      locationRequiredLabel="District context required"
      buildDefaultName={buildDefaultMmdaName}
      generalCommentsPlaceholder="Capture the broad observations for the MMDA here..."
      recommendationsPlaceholder="Capture district-level recommendations and follow-up actions here..."
    />
  );
}
